const NAME = 'catering';

export const SET_VARIANT = `${NAME}/SET_VARIANT`;

export const FETCH_CATEREDMEAL_RECEIVED = `${NAME}/FETCH_CATEREDMEAL_RECEIVED`;
export const FETCH_CATEGORY_CATEREDMEALS_REQUESTED = `${NAME}/FETCH_CATEGORY_CATEREDMEALS_REQUESTED`;
export const FETCH_CATEGORY_CATEREDMEALS_RECEIVED = `${NAME}/FETCH_CATEGORY_CATEREDMEALS_RECEIVED`;
export const FETCH_CATEGORY_CATEREDMEALS_FAILED = `${NAME}/FETCH_CATEGORY_CATEREDMEALS_FAILED`;
export const FETCH_CATEREDMEAL_FAILED = `${NAME}/FETCH_CATEREDMEAL_FAILED`;
